import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ScreenManagerService {
	mobile: boolean;
	width: number;
	height: number;
	readonly MAX_MOBILE_WIDTH = 768;
	private isMobileChange = new Subject<any>();
	isMobile$ = this.isMobileChange.asObservable();
	private isWidthChange = new Subject<any>();
	isWidth$ = this.isWidthChange.asObservable();
	private isHeightChange = new Subject<any>();
	isHeight$ = this.isHeightChange.asObservable();

	constructor() {
	}

	setMobile(width: number, defaultWidth = this.MAX_MOBILE_WIDTH) {
		this.mobile = width <= defaultWidth;
		this.width = width;
		this.setWidth(width);
		this.isMobileChange.next(this.mobile);
	}

	setWidth(width: number) {
		this.width = width;
		this.isWidthChange.next(width);
	}


	setHeight(height: number) {
		this.height = height;
		this.isHeightChange.next(height);
	}

	getWidth() {
		return this.width;
	}

	getHeight() {
		return this.height;
	}

	isMobile() {
		return this.mobile;
	}
}
